import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  // Inject Meta Pixel safely
  useEffect(() => {
    const pixelId = '1252242806993118';
    // Avoid double-injection
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      const n: any = window.fbq = function () {
        // @ts-ignore
        n.callMethod ?
        // @ts-ignore
        n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Append to head (or body) instead of relying on an existing <script> node
      const target = document.head || document.body || document.documentElement;
      if (target) {
        target.appendChild(script);
      }
    }
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      window.fbq('init', pixelId);
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  }, []);
  return <SalesPage data-id="element-0" />;
}